import React, { useState, useEffect } from 'react';

const EndText = ({ isAtEndPosition }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (isAtEndPosition) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, [isAtEndPosition]);

    const mainResumeBlockStyle = {
        position: 'fixed',
        right: '1%',
        top: '50%',
        transform: 'translateY(-50%)',
        // border: '1px solid #ff0000',
        padding: '10px',
        width: '735px',
        height: '600px',
        zIndex: 900,
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 1s ease-in-out',
    };

    const topBlocksContainerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '20px',
        marginBottom: '40px',
    };

    const topBlockStyle = {
        // border: '1px solid #00ff00',
        width: 'calc(33.33% - 14px)',
        height: '150px',
    };

    const contentContainerStyle = {
        background: 'rgba(0, 0, 0, 0.5)',
        padding: '20px',
        borderRadius: '10px',
        color: 'white',
        backdropFilter: 'blur(5px)',
        fontFamily: 'HelveticaNeue, Arial, sans-serif',
    };

    const headingStyle = {
        fontSize: '24px',
        marginBottom: '15px',
        fontWeight: 'normal',
        letterSpacing: '0.05em',
    };

    const textStyle = {
        fontSize: '16px',
        lineHeight: '1.6',
        letterSpacing: '0.03em',
        marginBottom: '20px',
    };

    const svgBlockStyle = {
        // border: '1px solid #00ffff',
        width: '300px',
        height: '150px',
        margin: '40px auto 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '24px',
        background: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(5px)',
        borderRadius: '10px',
        overflow: 'hidden',
    };

    const svgStyle = {
        width: '300px',
        height: 'auto',
        objectFit: 'contain',
        display: 'block',
        margin: 'auto',
        position: 'relative',
        right: '-25px',
        transform: 'scale(0.9)',
    };

    return (
        <div style={mainResumeBlockStyle} className="main-resume-block">
            <div style={topBlocksContainerStyle} className="top-blocks-container">
                <div style={topBlockStyle} className="top-block"></div>
                <div style={topBlockStyle} className="top-block"></div>
                <div style={topBlockStyle} className="top-block"></div>
            </div>
            
            <div style={contentContainerStyle} className="content-container">
                <h2 style={headingStyle} className="content-heading">Experience the Future</h2>
                <p style={textStyle} className="content-description">
                    Step into a world where classic design meets modern technology. 
                    The RX-7 FD represents more than just a car - it's a testament 
                    to engineering excellence and timeless aesthetics.
                </p>
            </div>

            <div style={svgBlockStyle} className="svg-block">
                <img 
                    src="TAG_NON_ANIMATED.svg" 
                    alt="TAG" 
                    style={svgStyle}
                />
            </div>
        </div>
    );
};

export default EndText; 